import { Reader, Writer } from "protobufjs/minimal";
import type {
  Device,
  Country,
  Language,
  ABTest,
  Config,
} from "../../../aysa_api/shared/v1/config.types";

export const decodeDevice = (reader: Reader): Device => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    case 4:
      return 4;
    default:
      return 0;
  }
};

export const encodeDevice = (writer: Writer, value: Device): Writer => {
  return writer.int32(value);
};

export const decodeCountry = (reader: Reader): Country => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    case 4:
      return 4;
    case 5:
      return 5;
    case 6:
      return 6;
    case 7:
      return 7;
    case 8:
      return 8;
    case 9:
      return 9;
    case 10:
      return 10;
    case 11:
      return 11;
    case 12:
      return 12;
    case 13:
      return 13;
    case 14:
      return 14;
    case 15:
      return 15;
    case 16:
      return 16;
    case 17:
      return 17;
    case 18:
      return 18;
    case 19:
      return 19;
    case 20:
      return 20;
    case 21:
      return 21;
    case 22:
      return 22;
    case 23:
      return 23;
    case 24:
      return 24;
    case 25:
      return 25;
    case 26:
      return 26;
    case 27:
      return 27;
    case 28:
      return 28;
    case 29:
      return 29;
    case 30:
      return 30;
    case 31:
      return 31;
    default:
      return 0;
  }
};

export const encodeCountry = (writer: Writer, value: Country): Writer => {
  return writer.int32(value);
};

export const decodeLanguage = (reader: Reader): Language => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    case 4:
      return 4;
    case 5:
      return 5;
    case 6:
      return 6;
    case 7:
      return 7;
    case 8:
      return 8;
    case 9:
      return 9;
    case 10:
      return 10;
    case 11:
      return 11;
    case 12:
      return 12;
    case 13:
      return 13;
    case 14:
      return 14;
    case 15:
      return 15;
    case 16:
      return 16;
    case 17:
      return 17;
    case 18:
      return 18;
    case 19:
      return 19;
    case 20:
      return 20;
    case 21:
      return 21;
    case 22:
      return 22;
    case 23:
      return 23;
    case 28:
      return 28;
    case 29:
      return 29;
    case 30:
      return 30;
    default:
      return 0;
  }
};

export const encodeLanguage = (writer: Writer, value: Language): Writer => {
  return writer.int32(value);
};

export const createBaseABTest = (): ABTest => {
  return {
    key: "",
    group: "",
  };
};

export const decodeABTest = (reader: Reader, length: number): ABTest => {
  const end = reader.pos + length;
  const message = createBaseABTest();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.key = reader.string();

        break;
      case 2:
        message.group = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeABTest = (writer: Writer, message: ABTest): Writer => {
  writer.uint32(10).string(message.key);
  writer.uint32(18).string(message.group);

  return writer;
};

export const createBaseConfig = (): Config => {
  return {
    country: 0,
    language: 0,
    device: 0,
    clientVersion: "",

    abTests: [],
  };
};

export const decodeConfig = (reader: Reader, length: number): Config => {
  const end = reader.pos + length;
  const message = createBaseConfig();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.country = decodeCountry(reader);

        break;
      case 2:
        message.language = decodeLanguage(reader);

        break;
      case 3:
        message.device = decodeDevice(reader);

        break;
      case 4:
        message.clientVersion = reader.string();

        break;
      case 5:
        message.traceId = reader.string();

        break;
      case 6:
        message.abTests.push(decodeABTest(reader, reader.uint32()));

        break;
      case 7:
        message.deviceId = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeConfig = (writer: Writer, message: Config): Writer => {
  encodeCountry(writer.uint32(8), message.country);
  encodeLanguage(writer.uint32(16), message.language);
  encodeDevice(writer.uint32(24), message.device);
  writer.uint32(34).string(message.clientVersion);
  if (message.traceId !== undefined) {
    writer.uint32(42).string(message.traceId);
  }
  for (const value of message.abTests) {
    encodeABTest(writer.uint32(50).fork(), value).ldelim();
  }
  if (message.deviceId !== undefined) {
    writer.uint32(58).string(message.deviceId);
  }

  return writer;
};
